import {z} from 'zod';

const countSchema = z
  .object({
    key: z.string().min(1),
    count: z.number().nonnegative().int(),
    area: z.number().nonnegative(),
  })
  .transform(({key, count, area}) => ({id: key, count, area}));

const countsSchema = countSchema
  .array()
  .transform((arr) => arr.sort((a, b) => b.count - a.count));

export const annotationStatsSchema = z.object({
  total: z.number().nonnegative().int(),
  severities: countsSchema,
  categories: countsSchema,
  tags: countsSchema,
  threeD: z
    .object({
      area: z.number().nonnegative().nullable(),
    })
    .nullable(),
});
